module.exports = __webpack_public_path__ + "static/lmsscreen-baac48d1b2798d7b95a3e2383202ac5e.png";